module.exports = __webpack_public_path__ + "static/media/Placeholder-image.ed952fdd.png";